import { render, staticRenderFns } from "./intake-size.vue?vue&type=template&id=249d9dab"
import script from "./intake-size.vue?vue&type=script&lang=js"
export * from "./intake-size.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports